import { createFileRoute } from "@tanstack/react-router";
import { AgentSkillDetailRoute } from "@/components/agents/agent-skills-route";

export const Route = createFileRoute("/$owner/agents/$agentId/skills/$skillKey")(
	{
		component: AgentSkillDetailPage,
	},
);

function AgentSkillDetailPage() {
	const { owner, agentId, skillKey } = Route.useParams();
	return (
		<AgentSkillDetailRoute
			owner={owner}
			agentId={agentId}
			skillKey={skillKey}
		/>
	);
}